import type { SVGProps } from 'react'

export function AldapaLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 326 170" role="img" aria-label="Aldapa Systems" {...props}>
      <path fill="currentColor" d="M8 116 47 11h25l39 105H87l-9-27H40l-9 27H8Zm38-45h26L59 32 46 71Z" />
      <text x="118" y="89" fill="currentColor" fontFamily="Arial, Helvetica, sans-serif" fontWeight="700" fontSize="50" letterSpacing="1">LDAPA</text>
      <path fill="currentColor" d="M96 103h226v13H96z" />
      <text x="112" y="155" fill="#767676" fontFamily="Arial, Helvetica, sans-serif" fontWeight="600" fontSize="29">Systems</text>
    </svg>
  )
}
